(function () {
  'use strict';

  angular
    .module('app.password-revovery', [])

    .directive('passwordRecovery', function () {
      return {
        restrict: 'E',
        bindToController: {
          token: '@',
          isTokenValid: '<',
          js: '@'
        },
        controllerAs: 'passwordRecoveryCtrl',
        /* @ngInject */
        controller: ["$element", "LoadService", function ($element, LoadService) {
          var ctrl = this;
          ctrl.$onInit = function () {
            LoadService.getService('AsyncPasswordService', { ctrl: ctrl, element: $element }, 'initModule');
          };
        }]
      };
    });

})();
